// extracted by mini-css-extract-plugin
export default {"heading":"Title_style_heading__1BL7C","rotate":"Title_style_rotate__XVUIy"};